<template>
  <ul :class="['dropdown-content fd:absolute hidden bg-gray-200 shadow-lg fd:w-[15rem]', props.isFirstCall ? 'top-5 right-0' : 'top-0 right-[15rem]']">
    <li class="relative dropdown fm:p-2" v-for="children in props.childrens" :key="children.id">
      <routerLink :to="{name:props.routeName,params:{slug:children.slug}}" class="hover:bg-gray-300 py-4 text-black px-4 block whitespace-no-wrap">{{children.title}}</routerLink>
      <NavbarDropdown :childrens="children.children" :isFirstCall="false" :routeName="props.routeName"/>
    </li>
  </ul>
</template>

<script>
export default {name:'NavbarDropdown'}
</script>

<script setup>
import {defineProps} from "vue";

const props = defineProps({
  'childrens':{
    type:Array,
    required:true
  },
  'isFirstCall':{
    type:Boolean,
    default:false,
  },
  'routeName':{
    type:String,
    required:true
  }
})
</script>